import { HOME_MASTER_ROUTE } from '../main/main.data';
import { GlobalSearchTypesEnum } from '../search-data/search-data.data';
import { TrackingScreenNamesEnum } from '../tracking/tracking.data';

export const SEARCH_ROUTE = 'search';
export const SEARCH_INVOICES_ROUTE = 'invoices';
export const SEARCH_ESTIMATES_ROUTE = 'estimates';
export const SEARCH_CREDIT_MEMOS_ROUTE = 'credit-memos';
export const SEARCH_PURCHASE_ORDERS_ROUTE = 'purchase-orders';
export const SEARCH_CLIENTS_ROUTE = 'clients';
export const SEARCH_ITEMS_ROUTE = 'items';
export const SEARCH_EXPENSES_ROUTE = 'expenses';
export const SEARCH_TRACKED_TIMES_ROUTE = 'tracked-times';
export const SEARCH_APPOINTMENTS_ROUTE = 'appointments';
export const HOME_SEARCH_ROUTE = `${HOME_MASTER_ROUTE}/${SEARCH_ROUTE}`;
export const DRAFT_TRACKED_TIME_ACTION = 'draft_tracked_time_action';
export const POST_PURCHASE_DIALOG_TYPE = 'post-purchase';

export interface IHomeSearchRouteData {
  inGlobalSearch: boolean;
  type: GlobalSearchTypesEnum;
  disableBulkActions: boolean;
}

export interface IPostPurchaseSurvey {
  title: string;
  header: string;
  trackingScreenName: TrackingScreenNamesEnum;
}

export enum TaskItemStateEnum {
  completed = 'completed',
  incomplete = 'incomplete',
  dismissed = 'dismissed',
}

export enum TaskItemTypeEnum {
  create_first_invoice = 'create_first_invoice',
  add_business_name = 'add_business_name',
  review_business_info = 'review_business_info',
  customize_invoice = 'customize_invoice',
  choose_payment_reminders = 'choose_payment_reminders',
  setup_paypal_payments = 'setup_paypal_payments',
  accept_stripe_card_payments = 'accept_stripe_card_payments',
}
